import React from 'react'
import PropTypes from 'prop-types'
import StateTag from './state-tag'
import { COLOR_STATE_TAG } from './constants'
import { CHECKOUT_STATE as ORDER_STATE } from '../../services/checkout/constants'
import values from 'lodash/values'

function getIconName(orderState) {
  switch (orderState) {
    case ORDER_STATE.EXPIRED:
    case ORDER_STATE.PAYMENT_FAIL:
      return 'warning'
    case ORDER_STATE.PAYMENT_OK:
      return 'pickup'
    case ORDER_STATE.PENDING:
      return 'clock2'
    case ORDER_STATE.COMPLETED:
    default:
      return 'finished-event'
  }
}
function getStateText(orderState) {
  switch (orderState) {
    case ORDER_STATE.PENDING:
      return 'Processing order'
    case ORDER_STATE.COMPLETED:
      return 'Completed'
    case ORDER_STATE.EXPIRED:
      return 'Expired'
    case ORDER_STATE.PAYMENT_OK:
      return 'Payment OK - Checkout pending'
    case ORDER_STATE.PAYMENT_FAILED:
      return 'Payment failed'
    case ORDER_STATE.ERROR:
    default:
      return 'Payment Failed'
  }
}

function getColorState(orderState) {
  switch (orderState) {
    case ORDER_STATE.COMPLETED:
    case ORDER_STATE.PROCESSING:
    case ORDER_STATE.PENDING:
    case ORDER_STATE.PAYMENT_OK:
      return COLOR_STATE_TAG.LIVE
    default:
      return COLOR_STATE_TAG.FINISHED
  }
}

const OrderStateTag = ({ orderState, className }) => (
  <StateTag
    iconName={getIconName(orderState)}
    text={getStateText(orderState)}
    colorState={getColorState(orderState)}
  />
)

OrderStateTag.propTypes = {
  orderState: PropTypes.oneOf(values(ORDER_STATE)),
  className: PropTypes.string
}

export default OrderStateTag



// WEBPACK FOOTER //
// ./src/ui/tags/order-state-tag.js